import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["votePanel"]

  votedFeedback(){
    this.votePanelTarget.innerHTML = "<span class='ml-3' style='color: #8DC647; font-weight: bold;'>" + this.votePanelTarget.getAttribute("data-vote-thanks-text") + "</span>"
  }
}
